export { default } from './MyWallet.container';
export { default as MyWalletForPremium } from './MyWalletForPremium.container';
